'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _styles = require('./styles.scss');

var _styles2 = _interopRequireDefault(_styles);

var _registrations = require('../registrations');

var _registrations2 = _interopRequireDefault(_registrations);

var _getPurchasedProductsHistoryByAccount = require('ifeis-isomorphic/lib/redux/actions/products/getPurchasedProductsHistoryByAccount');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RegistrationHistoryDirective = function () {
  function RegistrationHistoryDirective($scope, $ngRedux) {
    var _this = this;

    _classCallCheck(this, RegistrationHistoryDirective);

    this.$ngRedux = $ngRedux;
    $scope.$watch(function () {
      return _this.data;
    }, function (regHistoryData) {
      if (!regHistoryData) {
        return;
      }
      _this.logData = regHistoryData.log.map(function (record) {
        return _extends({}, record, {
          actor: {
            id: record.actor,
            fname: regHistoryData.actors[record.actor].fname,
            lname: regHistoryData.actors[record.actor].lname
          }
        });
      });
      _this.$ngRedux.dispatch((0, _getPurchasedProductsHistoryByAccount.getPurchasedProductsHistoryByAccount)(_this.feis, _this.dancer)).then(function (response) {
        _this.productLog = response.payload.map(function (product) {
          return _extends({}, product, { type: 'product', action: product.archived === true ? 'returned' : 'purchased' });
        });

        _this.logData = _this.logData.concat(_this.productLog).sort(function (a, b) {
          return b.timestamp - a.timestamp;
        });
      });
    });
  }

  _createClass(RegistrationHistoryDirective, [{
    key: 'getEventIcon',
    value: function getEventIcon(event) {
      switch (event) {
        case 'registered':
        case 'purchased':
          return 'fa-calendar-plus-o';
        case 'deregistered':
        case 'returned':
        case 'unregistered':
          return 'fa-calendar-times-o';
        default:
          return 'fa-calendar-o';
      }
    }
  }, {
    key: 'getEventName',
    value: function getEventName(id) {
      return this.data.events[id]['name'];
    }
  }, {
    key: 'getEventPreposition',
    value: function getEventPreposition(action) {
      switch (action) {
        case 'deregistered':
        case 'unregistered':
          return 'from';
        case 'registered':
        default:
          return 'for';
      }
    }
  }, {
    key: 'getNames',
    value: function getNames(event, type) {
      if (type === 'person' && event.actor === event.person) {
        return;
      }
      if (event[type] === this.me) {
        return 'you';
      } else {
        var prop = type + 's',
            nameMap = this.data[prop][event[type]];
        return nameMap.fname + ' ' + nameMap.lname;
      }
    }
  }]);

  return RegistrationHistoryDirective;
}();

exports.default = angular.module('ifeis.registration-history', []).directive('fRegistrationHistory', function () {
  return {
    bindToController: true,
    controller: 'RegistrationHistoryDirective',
    controllerAs: 'history',
    replace: true,
    scope: {
      data: '=',
      me: '@',
      feis: '@',
      dancer: '@'
    },
    template: require('./tpl.html')
  };
}).controller('RegistrationHistoryDirective', RegistrationHistoryDirective);


//////////////////
// WEBPACK FOOTER
// ./registration-history/index.js
// module id = 502
// module chunks = 0